module.exports = __webpack_public_path__ + "static/media/drink.8d214946.png";